<div class="top-header">
      <p-menubar [model]="[]" styleClass="header-menubar">
        <ng-template pTemplate="start">
          <img src="/logonew-removebg-preview.png" alt="Company Logo" class="top-logo" routerLink="/home" />
          <span class="lti-text">LTI 1.3 Platform</span>
          @for (item of items; track item.label) {
            <p-button
              [label]="item.label"
              [icon]="item.icon"
              (click)="item.command()"
              severity="secondary"
              styleClass="nav-btn"
            />&nbsp;|&nbsp;
          }
          @if (allowDebug && isUserLoggedIn()) {
              <p-button
                type="button"
                label="Debug"
                icon="pi pi-gauge"
                (click)="goDebugPage()"
                severity="secondary"
              />
            }
        </ng-template>
        <ng-template pTemplate="end">
          @if (isUserLoggedIn()) {
            <p-button
              type="button"
              label="Change Password"
              icon="pi pi-user-edit"
              (click)="goToChangePassword()"
              severity="success"
            />
            <p-button
              type="button"
              label="Logout"
              icon="pi pi-sign-out"
              (click)="logout()"
              severity="contrast"
            />
          }
        </ng-template>
    </p-menubar>
</div>